<template src="../templates/normal_fcont_100.html" />
<script>
import LabelFunMessage from '../components/LabelFunMessage'

import FuncSearchGalleryQR from '../components/FuncSearchGalleryQR'
import ReleaseDateForArticle from '../components/ReleaseDateForArticle'
import FuncSearchRecommendLink from '../components/FuncSearchRecommendLink'
import InfoMachineTranslation from '../components/InfoMachineTranslation'
import { Carousel,Slide } from 'uiv'
import { mapState, mapGetters } from "vuex";

export default {
  name: 'app',
  data() {
    return {
      articleId: '100',
      app_root: process.env.VUE_APP_ROOT
    };
  },
  components: {
    LabelFunMessage, Carousel,Slide,FuncSearchRecommendLink,
    FuncSearchGalleryQR,ReleaseDateForArticle,InfoMachineTranslation
  },
  computed:{
    ...mapGetters(["isJpTemplate"]),
    ...mapState(["os","lg2"]),
    isMobile: function() {
      return this.os == 'ios' || this.os == 'ard'
    },
    selectedTraditionalChinese: function () {
      return this.lg2 == "zh";
    },
    selectedThai: function () {
      return this.lg2 == "th";
    },
    supportLinePrint: function () {
      if (this.isJpTemplate) {
        return true;
      }else {
        if (this.selectedTraditionalChinese || this.selectedThai) {
          return true;
        }else {
          return false;
        }
      }
    }
  },
  metaInfo() {
    return {
      title: this.$store.state.messages.messages['100-1'],
    meta: [
      { name: 'description', content: this.$store.state.messages.messages['100-2']}
    ]};

  }
};
</script>
<style >

</style>

